// shared/ui/imagenesHandoff.js  (ui). Traspaso de imágenes pendientes/fallidas entre la ruta de crear y la de editar.
// Crear y editar son rutas distintas con componentes distintos: al hacer `history.replace` a /edit/:uuid la página se
// desmonta y el editor pierde sus archivos (File no se puede recargar). Se guardan aquí, en memoria del módulo,
// indexadas por el uuid de la entidad ya creada; la página de edición las lee al montar el editor y las consume.
// (location.state también serviría, pero sobrevive a recargas con archivos ya inválidos y mezcla UI con router.)
const store = new Map();

export const guardarPendientesParaEdicion = (uuid, items) => {
  if (uuid && items && items.length) store.set(uuid, items);
};

// Lectura destructiva: la toma la página de edición al montar el editor (useState inicial, una sola vez).
// No se limpia al desmontar la página de crear: ese cleanup correría DESPUÉS de guardar y antes de que cargue la de editar.
export const tomarPendientes = uuid => {
  const items = (uuid && store.get(uuid)) || [];
  store.delete(uuid);
  return items;
};
